import axios from "axios";

const getConfiguracionIntegraciones = async () => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");

  const userData = {
    nic: formattedNic,
    token: token,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
  };
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Helper/ConfiguracionIntegraciones`, userData);
  return response.data;
};

const configuracionIntegraciones = {
  getConfiguracionIntegraciones,
};

export default configuracionIntegraciones;
